import { render, staticRenderFns } from "./base-step.vue?vue&type=template&id=04d408db&scoped=true"
import script from "./base-step.vue?vue&type=script&lang=js"
export * from "./base-step.vue?vue&type=script&lang=js"
import style0 from "./base-step.vue?vue&type=style&index=0&id=04d408db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d408db",
  null
  
)

export default component.exports